<template>
    <div class="px-4 py-4 modal-padding myt-modal">
        
        <div class="billing-details-title">Terms and Conditions:
            <div class="close-outer float-right top-zero" @click="onClose({...data, payNow: true, status:false})">
          <img src="../../../assets/img/close-icon.svg" class="close-icon" />
        </div>
        </div>
        <div class="terms-scroll">
            <div class="tac-head">As a paid user of the website <a href="https://myt.eduracle.com/" target="_blank"> myt.eduracle.com</a>, I understand and agree to the following terms and conditions:</div>
        <ol>
            <li class="tac-head">
                I am aware that once the payment is made for a particular test, I will not be able to change any question present in that test.
            </li>
            <li class="tac-head">
                I have reviewed the test paper that I am downloading and am satisfied about the quality, accuracy and relevance of the questions, solutions and answer key given on the platform. I will not hold eduracle accountable for any loss or damages that may arise due to any mistake in the answer key or solution given here.
            </li>
            <li class="tac-head">
                I understand that payment once made will not be returned or refunded, partially or completely under any circumstances.
            </li>
            <li class="tac-head">
                I understand that the payment made here is on a pay per download basis and eduracle is liable to ensure that the the facility to download the question paper, answer key or the solutions works once and eduracle can on its sole descretion remove the facility to download the question paper, answer key or the solutions multiple times.
            </li>
            <li class="tac-head">
                I agree not to indulge in unauthorised reproduction and sale of the files downloaded from this platform that I do not have any intellectual property rights to the questions, answers or the solutions downloaded from this platform.
            </li>
        </ol>
        </div>
        <div class="text-center">
            <v-btn centered color="primary" @click="onClose({...data, payNow:true, status:false})">OK</v-btn>
        </div>
    </div>
</template>
<script>
export default {
    props: ["onClose", "data", "status"]
};
</script>